<style scoped>
  .bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
  }

  .msg-show {
    position: fixed;
    width: 14rem;
    padding: 1.2rem 1rem;
    top: 50%;
    left: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    margin-left: -7rem;
    border-radius: 0.25rem;
    background: #fff;
    font-size: 0.75rem;
    line-height: 1.4;
    color: #333;
    z-index: 9999;
  }

  .style1 .msg-show {
    border-radius: 0;
  }

  .msg-show a {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.25rem;
    color: #cccccc;
  }

  .style2 .msg-show{
    background-color:rgba(42, 43, 47,0.9);
    color:#fff;
  }
  .style2 .bg{
    background-color: transparent;
  }
</style>
<template>
  <div :class="style">
    <transition name="fade" mode="out-in" appear>
      <div v-show="s" class="bg" @click="hide"></div>
    </transition>
    <transition name="fade" mode="out-in" appear>
      <div v-show="s" :class="(s)?'msg-show showing':'msg-show'">
        <div class="show-content">
          <div class="f-tac f-tac" v-html="msgShow"></div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        timer: null,
        s: false,
        msg: '',
        cb:'',
      };
    },
    props:['styleType'],
    computed: {
      msgShow() {
        return this.msg.replace(/<script.*>/, '').replace(/<\/script>/, '');
      },
      style() {
        return 'style'+ this.styleType;
      }
    },
    methods: {
      show(msg, time, cb) {
        if(!msg && msg != 0){
          return
        }
        let self = this;
        this.cb=cb;
        self.msg = msg;
        self.s = true;
        if (self.timer) {
          clearTimeout(self.timer);
          self.timer = null;
        }
        let delay = msg.toString().replace(/<[^>]+>/g,'').replace(/^\s+|\s+$/gm,'').length>12?3500:2000;
        self.timer = setTimeout(() => {
          self.hide();
        }, (time) ? time : delay);
      },
      hide() {
        const self = this;
        if (self.timer) {
          clearTimeout(self.timer);
          self.timer = null;
        }
        this.s = false;
        if(typeof this.cb === 'function'){
          this.cb();
          this.cb = '';
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/bjxy-component/toast/toast.vue